var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPractitionerDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 12C43.7565 12 39.6869 13.6857 36.6863 16.6863C33.6857 19.6869 32 23.7565 32 28C32 32.2435 33.6857 36.3131 36.6863 39.3137C39.6869 42.3143 43.7565 44 48 44C52.2435 44 56.3131 42.3143 59.3137 39.3137C62.3143 36.3131 64 32.2435 64 28C64 23.7565 62.3143 19.6869 59.3137 16.6863C56.3131 13.6857 52.2435 12 48 12ZM48 56C35.984 56 12 62.032 12 74V80C12 82.208 13.792 84 16 84H80C82.208 84 84 82.208 84 80V74C84 62.032 60.016 56 48 56Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractitionerDefault);
export default __webpack_public_path__ + "static/media/practitioner-default.87d9341e30593fd048c7bb8654b30ee9.svg";
export { ForwardRef as ReactComponent };